export default __webpack_public_path__ + "static/media/CSS3.f34b047e.png";